import { Box, Spinner } from '@factorialco/deprecated-design-system'

import type { IncidenceQueryData } from 'modules/bookkeepers/hooks/useGetIncidences'
import { useGetFolders } from 'modules/documents/hooks/useGetFolders'
import { SPACES } from 'modules/documents/lib/constants'

import { Links } from './Links'

interface Props {
  incidence?: IncidenceQueryData
}

const MoreInformation = ({ incidence }: Props) => {
  const incidenceType = incidence?.name
  const employeeId = incidence?.employeeId
  const legalEntityId = incidence?.legalEntityId
  const companyId = incidence?.legalEntity?.companyId
  const targetId = incidence?.targetId

  const { folders, loading } = useGetFolders({
    rootFolders: true,
    space: SPACES.EMPLOYEE_MY_DOCUMENTS,
    companyId: companyId,
  })

  if (!incidenceType || !employeeId || !companyId || !legalEntityId || loading) return null

  return (
    <Box paddingLeft="s24" paddingTop="s16" paddingBottom="s24">
      <Box gap="s8" paddingTop="s16" component="ul">
        {loading ? (
          <Spinner />
        ) : (
          <Links
            companyId={companyId}
            employeeId={employeeId}
            incidenceType={incidenceType}
            targetId={targetId}
            legalEntityId={legalEntityId}
            folders={folders}
          />
        )}
      </Box>
    </Box>
  )
}

export default MoreInformation
